import { BooleanQueryErrorCode } from './booleanQuery';

export const booleanQueryErrorMessageId = (
  code: BooleanQueryErrorCode,
): string => {
  const messageIds: Record<BooleanQueryErrorCode, string> = {
    pure_negative: 'searchform.error.purenegative',
    unbalanced_parenthesis: 'searchform.error.unbalancedparenthesis',
    empty_group: 'searchform.error.emptygroup',
    dangling_operator: 'searchform.error.danglingoperator',
  };

  return messageIds[code];
};
